import React, { useState, useEffect } from 'react';

interface TimerProps {
  startFrom: number;  // Время начала обратного отсчета в минутах
  dangerFrom: number; // Минуты, с которых цвет текста изменится на опасный
}

const Timer: React.FC<TimerProps> = ({ startFrom, dangerFrom }) => {
  const [time, setTime] = useState(startFrom * 60 * 1000); // Преобразуем минуты в миллисекунды
  const [showCookieConsent, setShowCookieConsent] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prevTime => (prevTime > 0 ? prevTime - 10 : 0)); // Уменьшаем время на 10 миллисекунд
    }, 10);

    return () => clearInterval(interval); // Очищаем интервал при размонтировании компонента
  }, []);

  const minutes = Math.floor(time / (60 * 1000));
  const seconds = Math.floor((time % (60 * 1000)) / 1000);
  const milliseconds = Math.floor((time % 1000) / 10);

  const isDanger = minutes < dangerFrom;
  const timerColor = isDanger ? '#f31260' : '#006FEE';

  const handleAcceptCookies = () => {
    setShowCookieConsent(false);
    // Сохранение состояния в localStorage, чтобы баннер больше не появлялся
    localStorage.setItem('cookiesAccepted', 'true');
  };

  useEffect(() => {
    // Проверяем, если пользователь уже принял куки, баннер не показывается
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (cookiesAccepted === 'true') {
      setShowCookieConsent(false);
    }
  }, []);

  return (
    <div style={{ position: 'fixed', zIndex: '9999', bottom: 0, left: 0, right: 0 }}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          backgroundColor: '#ffffff',
          textAlign: 'center',
          padding: '16px 0',
          borderRadius: showCookieConsent ? '16px 16px 0px 0px' : '0px',
          boxShadow: '0 -10px 15px -3px rgb(0 0 0 / 0.1), 0 -4px 6px -4px rgb(0 0 0 / 0.1)',
        }}
      >
        <p style={{ fontWeight: '550', color: '#71717A' }}>Tiempo restante:</p>
        <div
          style={{
            color: timerColor,
            fontSize: '16px',
            fontWeight: '700',
            minWidth: '72px',
            textAlign: 'left',
          }}
        >
          {`${minutes}:${seconds < 10 ? '0' + seconds : seconds}:${milliseconds < 10 ? '0' + milliseconds : milliseconds}`}
        </div>
      </div>
      {showCookieConsent && (
        <div
          style={{
            backgroundColor: '#f9f9f9',
            padding: '10px 20px',
            textAlign: 'center',
            fontSize: '14px',
            color: '#333',
            borderRadius: '0px 0px 16px 16px',
            boxShadow: '0 -4px 6px -4px rgb(0 0 0 / 0.1)',
          }}
        >
          <span>
            Este sitio utiliza cookies para mejorar la experiencia del usuario.{' '}
          </span>
          <button
            onClick={handleAcceptCookies}
            style={{
              color: '#006FEE',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '14px',
              padding: 0,
            }}
          >
            Aceptar
          </button>
        </div>
      )}
    </div>
  );
};

export default Timer;
